import { referencableType_Hidden, referencableType_MultiValue, referencableType_Property, referencableType_SingleValue } from './types.js';
export const referencableTypes_LabelMap = {
    [referencableType_Hidden]: 'Hidden',
    [referencableType_Property]: 'Property',
    [referencableType_SingleValue]: 'Single Value',
    [referencableType_MultiValue]: 'Multi Value',
};
export const referencableTypes_TypeListingRules = {
    [referencableType_Hidden]: {
        whitelist: [],
        blacklist: [],
    },
    [referencableType_Property]: {
        whitelist: [referencableType_SingleValue, referencableType_MultiValue],
        blacklist: [],
    },
    [referencableType_SingleValue]: {
        whitelist: [referencableType_Property],
        blacklist: [referencableType_MultiValue],
    },
    [referencableType_MultiValue]: {
        whitelist: [referencableType_Property],
        blacklist: [referencableType_SingleValue],
    },
};
export const cleanItem_Referencable = Object.freeze({
    label: 'New Referencable',
    type: [],
    extends: [],
    prototypes: [],
    properties: {},
    dbRefs: [],
});
//# sourceMappingURL=consts.js.map